<template>
  <div
    class="cbg-white-container input-container theme--light health-vcard v-card p-16 border-card"
    :class="{'active':healthList.length>5}"
  >
    <v-col cols="12" class="mt-2 pl-0 pr-0">
      <div class="table-div overflow-x" :class="{'overflow-y':healthList.length>5}">
        <table class="table userlistTable table-width small-table-width border-left border-right">
          <thead>
            <tr class="table-success">
              <th>Owner Name</th>
              <th>Centre Name</th>
              <th>Package Name</th>
              <th>Status</th>
              <th>Type of Package</th>
              <th>Number of bookings</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>
                <input
                  class="form-control"
                  v-model="ownerName"
                  @input="getHealthPackageList()"
                  placeholder="Owner Name"
                />
              </td>
              <td>
                <input
                  class="form-control"
                  v-model="centerName"
                  @input="getHealthPackageList()"
                  placeholder="Center Name"
                />
              </td>
              <td>
                <input
                  class="form-control"
                  v-model="healthPackageName"
                  @input="getHealthPackageList()"
                  placeholder="Package Name"
                />
              </td>
              <td>
                <v-select
                  outlined
                  hide-details
                  v-model="packageStatus"
                  :items="[
                    { name: 'All', value: '' },
                    { name: 'Active', value: true },
                    { name: 'Inactive', value: false },
                  ]"
                  persistent-hint
                  item-text="name"
                  item-value="value"
                  @change="getHealthPackageList()"
                />
              </td>
              <td>
                <v-container fluid grid-list-xl class="ml-0 mr-0 health-select-box">
                  <v-select
                    v-model="healthPackageType"
                    placeholder="Select Centre"
                    :items="healthPackageTypeList"
                    item-text="name"
                    item-value="id"
                    multiple
                    content-class="week"
                    small-chips
                    cache-items
                    outlined
                    attach
                    name="healthPackageType"
                    hide-details
                    :return-object="false"
                  >
                    <template v-slot:prepend-item>
                      <v-checkbox
                        class="px-3"
                        @mousedown.prevent
                        @change="HP_type_toggle"
                        :color="
                          healthPackageType && healthPackageType.length > 0
                            ? 'indigo darken-4'
                            : ''
                        "
                        v-model="hpTypeSelectAll"
                        :label="'Select All'"
                        hide-details
                      ></v-checkbox>
                    </template>

                    <template v-slot:selection="{ item, index }">
                      <v-chip v-if="index <= 1">
                        <span>{{ item.name }}</span>
                      </v-chip>
                      <span v-if="index === 2" class="grey--text text-caption">
                        (+{{
                        healthPackageType && healthPackageType.length - 2
                        }}
                        others)
                      </span>
                    </template>
                  </v-select>
                </v-container>
              </td>
              <td>
                <v-select
                  outlined
                  hide-details
                  v-model="sortBy"
                  :items="[
                    { name: 'All', value: '' },
                    { name: 'Higher', value: 'Desc' },
                    { name: 'Lower', value: 'Asc' },
                  ]"
                  item-text="name"
                  item-value="value"
                  @change="getHealthPackageList()"
                />
              </td>
              <td></td>
            </tr>

            <tr v-for="(healtPackageDetails, i) in healthList" :key="i">
              <td>
                <p class="mb-0">{{ healtPackageDetails.center.owner.first_last_name }}</p>
              </td>
              <td>
                <p class="mb-0">{{ healtPackageDetails.center.name }}</p>
                <!-- <small class="mb-0"
                  ><b
                    >{{
                      healtPackageDetails.center.address.sublocality_level_1
                    }},{{
                      healtPackageDetails.center.address.sublocality_level_2
                    }}</b
                  ></small
                >-->
              </td>
              <td>
                <p class="mb-0">{{ healtPackageDetails.health_package.name }}</p>
                <!-- <small class="mb-0"
                  ><b>{{ healtPackageDetails.health_package_type }}</b></small
                >-->
              </td>
              <td>
                <p v-if="healtPackageDetails.health_package.is_active" class="mb-0">Active</p>
                <p v-else class="mb-0">Inactive</p>
              </td>

              <td>
                <p class="mb-0">{{ healtPackageDetails.health_package.health_package_type }}</p>
              </td>
              <td>
                <h5 class="m-0">{{ healtPackageDetails.health_package.bookings_count }}</h5>
              </td>
              <td>
                <router-link
                  :to="{
                    name: 'Health Package Details',
                    query: { healtpackage: healtPackageDetails },
                  }"
                  class="text-capitalize m-0"
                >
                  <v-btn color="primary" text>View Details</v-btn>
                </router-link>
              </td>
            </tr>
          </tbody>
        </table>
        <div v-if="isEmpty">
          <h2 class="text-center pt-4">No Data Found</h2>
        </div>
      </div>
    </v-col>
    <div v-if="showLoader && healthList.length === 0">
      <loader v-if="showLoader"></loader>
    </div>

    <pagination
      class="pagination-block"
      v-if="healthList.length > 0"
      :recordPerPage="recordPerPage"
      :currentPage="currentPage"
      :total="total"
      @changePage="changePage"
    />
  </div>
</template>

<script>
import { bus } from "@/main.js";
import config from "@/config.js";
const loader = () => import("@/components/loader.vue");
export default {
  data() {
    return {
      currentPage: 1,
      recordPerPage: 8,
      packageStatus: "",
      healthList: [],
      healthPackageName: "",
      centerName: "",
      ownerName: "",
      sortBy: "",
      userType: "admin",
      showLoader: false,
      totalPage: 1,
      total: 0,
      isEmpty: false,
      healthPackageTypeList: [],
      healthPackageType: [],
      hpTypeSelectAll: false
    };
  },

  computed: {
    likesHpCenter() {
      return (
        this.healthPackageType.length === this.healthPackageTypeList.length
      );
    },
    likesSomeHpCenter() {
      return this.healthPackageType.length > 0 && !this.likesHpCenter;
    },
    icon() {
      if (this.likesHpCenter) return "mdi-close-box";
      if (this.likesSomeHpCenter) return "mdi-minus-box";
      return "mdi-checkbox-blank-outline";
    }
  },
  mounted() {
    this.getHealthPackageList();
    this.getHealthPackageType();
  },

  components: {
    loader,
    pagination: () => import("@/views/common/Pagination")
  },

  created() {
    bus.$emit("CHAT_BREADCRUMB_CHANGE", [
      {
        text: "Home",
        disabled: false,
        to: "/"
      },
      {
        text: "Health Package",
        disabled: true,
        to: ""
      }
    ]);
  },

  methods: {
    HP_type_toggle() {
      this.$nextTick(() => {
        if (this.likesHpCenter) {
          this.healthPackageType = [];
        } else {
          this.healthPackageType = this.healthPackageTypeList.slice();
          this.healthPackageType = this.healthPackageTypeList.slice();
        }
      });
    },

    getHealthPackageList() {
      let url = `${config.DIAGNOSTICS_URL}api/v1/health-package/list`;
      this.showLoader = true;
      this.total = 0;
      let obj = {
        records_per_page: this.recordPerPage,
        page: this.currentPage,
        health_package_name: this.healthPackageName,
        center_name: this.centerName,
        owner_name: this.ownerName,
        sort_by: this.sortBy,
        user_type: this.userType
      };
      if (this.healthPackageType) {
        if (typeof this.healthPackageType[0] === "object") {
          obj.types = this.healthPackageType.map(data => data.id);
        } else {
          obj.types = this.healthPackageType;
        }
      }

      if (this.packageStatus == true || this.packageStatus == false) {
        obj.status = this.packageStatus;
      }
      this.$http.get(url, { params: obj }).then(response => {
        if (response.body.status) {
          this.showLoader = false;
          if (response.body.data.data.length) {
            this.healthList = response.body.data.data;
            this.isEmpty = false;
            this.totalPage = response.body.data.total / this.recordPerPage;
            if (response.body.data.total % this.recordPerPage !== 0)
              this.totalPage = parseInt(JSON.stringify(this.totalPage)) + 1;
            this.total = response.body.data.total;
          } else {
            this.healthList = [];
            this.isEmpty = true;
          }
        } else {
          this.showLoader = false;
        }
      });
    },
    changePage(page) {
      this.currentPage = page.currentPage;
      this.getHealthPackageList();
    },
    getHealthPackageType() {
      this.$http
        .get(`${config.DIAGNOSTICS_URL}api/v1/health_package_type`)
        .then(res => {
          if (res.body.status) {
            this.healthPackageTypeList = res.body.data;
          }
        });
    }
  },

  watch: {
    healthPackageType(val) {
      this.getHealthPackageList();
      if (this.healthPackageTypeList.length === val.length) {
        this.hpTypeSelectAll = true;
      } else {
        this.hpTypeSelectAll = false;
      }
    }
  }
};
</script>